<script lang="ts">
    import type { Writable } from 'svelte/store'

    import { gettext as _ } from 'hydria/services/gettext'

    import type { SaveError } from 'wdom/zone/zone'

    interface Props {
        status: Writable<'loading' | 'ready' | 'not-found' | 'error'>
        saveErrors: Writable<SaveError[]>
        class?: string | null
    }

    let { status, saveErrors, class: classes = null }: Props = $props()
</script>

{#if $status == 'ready' && $saveErrors.length}
    <div>
        <div class="standalone-title text-danger">{$_('Save failed')}</div>
        <div class="card{classes ? ` ${classes}` : ''}">
            <div class="card-body">
                <p>{$_('Your changes could not be saved:')}</p>
                <ul>
                    {#each $saveErrors as serror}
                        {#if serror.raw == null}
                            <li><strong>{serror.record}</strong>: ({serror.type}) {serror.message}</li>
                        {:else}
                            <li>{serror.raw}</li>
                        {/if}
                    {/each}
                </ul>
            </div>
        </div>
    </div>
{/if}
